export const useStyles = () => {
    return {
        alignHorizontal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        add: {
            fontSize: '2rem',
            color: 'secondary.100'
        },
        filter: {
            fontSize: '1.5rem',
        },
    }
}